import apiClient from '../api';

export async function getSeasonsByTeam(teamId) {
    const { data } = await apiClient.get('/seasons', { params: { teamId } });
    return data;
}

export async function createSeason(teamId, name) {
    const { data } = await apiClient.post('/seasons', { teamId, name });
    return data;
}

export async function deleteSeason(seasonId) {
    await apiClient.delete(`/seasons/${seasonId}`);
}

export async function getPhases() {
    const { data } = await apiClient.get('/seasons/phases');
    return data; // [{ value: 'PRIMERA_FASE', label: '1a Fase' }, ...]
}

export async function assignPhase(matchDayId, seasonId, phase) {
    const { data } = await apiClient.patch(`/matchdays/${matchDayId}/phase`, { seasonId, phase });
    return data;
}

export async function getStandings(teamId, phase) {
    const params = phase ? { phase } : {};
    const { data } = await apiClient.get(`/teams/${teamId}/standings`, { params });
    return data;
}

export async function createStanding(teamId, payload) {
    const { data } = await apiClient.post(`/teams/${teamId}/standings`, payload);
    return data;
}

export async function updateStanding(teamId, id, payload) {
    const { data } = await apiClient.put(`/teams/${teamId}/standings/${id}`, payload);
    return data;
}

export async function deleteStanding(teamId, id) {
    await apiClient.delete(`/teams/${teamId}/standings/${id}`);
}
